// Browser stand-in for the `tmp` package. The renderer's withTmpDir/withTmpFile
// helpers call tmp.dir/tmp.file with a (err, path, [fd], cleanup) callback and
// then read/write that path through the fs layer. We hand back unique virtual
// paths under /vortex/temp (which the fs shim serves from the session overlay);
// cleanup best-effort removes them.
//
// Without this, `tmp` resolves to an empty object and `tmp.file is not a
// function` aborts flows like the extension-list fetch (the webpack-minified
// name for the shared empty module can appear as `json_socket...`).
let counter = 0;

function uniqueName(options) {
    counter += 1;
    const opts = options ?? {};
    const prefix = opts.prefix ?? "tmp";
    const postfix = opts.postfix ?? "";
    return `/vortex/temp/${prefix}-${Date.now()}-${counter}${postfix}`;
}

function cleanupPath(p) {
    return () => {
        // fire-and-forget removal from the overlay (fsa-core exposes rm)
        try {
            globalThis.__vortexFsa?.rm?.(p)?.catch?.(() => undefined);
        } catch (err) {
            /* nothing to clean up */
        }
    };
}

function splitArgs(optionsOrCb, maybeCb) {
    if (typeof optionsOrCb === "function") {
        return { options: {}, cb: optionsOrCb };
    }
    return { options: optionsOrCb ?? {}, cb: maybeCb };
}

function dir(optionsOrCb, maybeCb) {
    const { options, cb } = splitArgs(optionsOrCb, maybeCb);
    const p = uniqueName(options);
    setTimeout(() => cb(null, p, cleanupPath(p)), 0);
}

function file(optionsOrCb, maybeCb) {
    const { options, cb } = splitArgs(optionsOrCb, maybeCb);
    const p = uniqueName(options);
    // open through the fs shim so the callback gets a real fd backed by the
    // fd table — callers (fsAtomic.writeFileAtomic) write to the temp via fd
    const fs = require("./fs.cjs");
    fs.open(p, "w", (err, fd) => {
        if (err) {
            cb(err);
            return;
        }
        cb(null, p, fd, () => {
            fs.close(fd, () => undefined);
            cleanupPath(p)();
        });
    });
}

module.exports = {
    dir,
    file,
    dirSync: (options) => ({
        name: uniqueName(options),
        removeCallback: () => undefined,
    }),
    fileSync: (options) => ({
        name: uniqueName(options),
        fd: -1,
        removeCallback: () => undefined,
    }),
    tmpNameSync: (options) => uniqueName(options),
    tmpName: (optionsOrCb, maybeCb) => {
        const { options, cb } = splitArgs(optionsOrCb, maybeCb);
        setTimeout(() => cb(null, uniqueName(options)), 0);
    },
    setGracefulCleanup: () => undefined,
};
